/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useIntl } from "react-intl";
import { PageTitle } from "../../components/layout/core";
const DashboardView: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: "MENU.DASHBOARDView" })}
      </PageTitle>
      <h1>teacher</h1>
    </>
  );
};

export { DashboardView };
